import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  roleText: {
    color: `${token.colorTextDescription}`
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 4,
    backgroundColor: token.primary.primary3
  },
  timeWrapper: {
    minWidth: 100
  },
  card: {
    borderBottom: `1px solid ${token.colorBorder}`,
    borderRadius: 0
  }
}))
